module.exports = __webpack_public_path__ + "img/avatar-drinking-default.758397bf.png";